// src/components/recepie-item/Recipe.jsx
import React, { useCallback, useContext } from "react";
import "./recepie.css";
import { ThemeContext } from "../../App";
import Swal from "sweetalert2";
import { useFavorites } from "../../utils/favorites";

const toast = (icon, title) =>
  Swal.fire({ toast: true, position: "bottom", icon, title, showConfirmButton: false, timer: 1500 });

const Recipe = ({ item, id, image, title, onViewRecipe, onRemoveFavorite }) => {
  const { theme } = useContext(ThemeContext);
  const { isFavorite, addFavorite, removeFavorite } = useFavorites();
  const saved = isFavorite(item?.id ?? id);

  const toggleFav = useCallback(() => {
    try {
      if (saved) {
        removeFavorite(item.id);
        toast("success", "Removed from favorites");
      } else {
        addFavorite(item);
        toast("success", "Added to your favorites");
      }
    } catch (e) {
      console.error("Failed to save favorite:", e);
      Swal.fire({ icon: "error", title: "Error", text: "Failed to save favorite." });
    }
  }, [item, saved, addFavorite, removeFavorite]);

  return (
    <article className={`recipe-card ${theme ? "dark" : ""}`}>
      {/* Clickable Image */}
      <button
        className="recipe-img-btn"
        onClick={() => onViewRecipe(id)}
        aria-label={`View ${title}`}
      >
        <img src={image} alt={title} className="recipe-img" loading="lazy" />
        <div className="recipe-img-overlay">
          <span className="recipe-view-text">View Recipe</span>
        </div>
      </button>

      {saved && !onRemoveFavorite && (
        <span className="recipe-saved-badge" title="In your favorites" aria-label="In your favorites">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
        </span>
      )}

      <div className="recipe-body">
        <h3 className="recipe-title">{title}</h3>

        <div className="recipe-actions">
          {onRemoveFavorite ? (
            <button
              className="recipe-btn remove"
              onClick={() => onRemoveFavorite(id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-8 0h8m-8 5v8m4-8v8m4-8v8" />
              </svg>
              Remove
            </button>
          ) : (
            <button
              className={`recipe-btn fav ${saved ? "saved" : ""}`}
              onClick={toggleFav}
              aria-pressed={saved}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill={saved ? "currentColor" : "none"}
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              {saved ? "Saved" : "Favorite"}
            </button>
          )}

          <button
            className="recipe-btn view"
            onClick={() => onViewRecipe(id)}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            View
          </button>
        </div>
      </div>
    </article>
  );
};

export default Recipe;
